import React, { useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import CarReservationsTable from "./CarReservationsTable"
import RoomReservationsTable from "./RoomReservationsTable"
import ReservationTab from "./ReservationTab"

export default function ReservationsList() {
  const { t } = useTranslation()
  const [reservationType, setReservationType] = useState(localStorage.getItem('reservationType') || 'car')

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t(reservationType + " Reservations")} />

       <ReservationTab setReservationType={setReservationType} />

        {reservationType === 'car' && <CarReservationsTable/>}
        {reservationType === 'room' && <RoomReservationsTable/>}
      </div>
    </div>
  )
}
